<template>
  <div class="qr-code-wrp">
    <img :src="qrCodeImgSource" alt="">
  </div>
</template>

<script>
import qrCodeHelper from '@/helpers/qr-code-helper'

export default {
  props: {
    hasMarginRight: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      qrCodeImgSource: null,
    }
  },
  mounted() {
    qrCodeHelper.setPresentationQRCode()
    this.qrCodeImgSource = this.$store.state.presentation.qrcode // To make sure SideCenterInviteAudience gets qrCode download link
  },
}
</script>

<style lang="scss" scoped>
.qr-code-wrp {
  @apply p-2 rounded-xl;
  background-color: #fff;
}
</style>
